import React, { useState, useEffect } from 'react';
import WarpBackground from './WarpBackground';
import './IntroSequence.css';

const introTextChunks = [
	'Once you plug-in to this alt-universe storyline, you feel as though you’re actually traveling. In fact, you’re not sure if your eyes are open, or if you’re just seeing this in your mind’s eye, but you can literally feel yourself moving, seemingly at the speed of thought—which, it occurs to you, is faster than light speed.',
	'You didn’t even know this was possible. Yet… you catch your breath to look around. You’re being transported, it would appear, through… a wormhole? Who knows? All you know is that, you’re somewhere in what appears to be the universe, yet—you’re not freezing to death, and you’re not suffocating… this is… weird.',
	'You can see stars, and it’s like… every star that your eyes settle on—you’re immediately there, and zoom right past. You comprehend, ok, this is faster than light speed, because you’re pretty sure the closest star to us is at least several light years away.',
	'Yet, you shoot past each of these as soon as you focus your gaze on any star, seemingly randomly. You try to regain a bit of control. You close your eyes, and you feel as though you’re still moving, which is disconcerting, so you open them again.',
	'This time, you’re able to pick and choose which stars you focus on, somewhat, and you feel as though you’re meant to be heading somewhere.',
	'You grow a bit anxious that your random selection of stars to focus on (and almost immediately arrive at, and zoom by) is not going to get you where you need to go but, things slowly start to slow down for you.',
	'Or, rather, you’re able to perceive in your peripheral, more details of planets, moons—places.',
	'You continue to get a stronger and stronger sense that you’re headed somewhere specific, and you follow that sense, almost as if you’d gained a 6th sense.',
	'“This is exactly how Toucan Sam must feel when he’s compelled to hunt down Fruit Loops merely by following his nose,” you openly wonder, unironically comparing the majesty of the entire universe—and your newfound ability to navigate it at “Thought Speed” (once you focus on it, you’re there)—with…the breakfast cereal commercials of your youth.',
	'Granted, they’re also still a guilty pleasure. In fact, just the other day—⁉️',
	'—You abruptly come to a halt, and see a digital display, on top of what looks like a digital, pillar-type stand, flashing the names and, apparently, huh 🤔…',
	'… some Characters that you (instantly?) perceive are of this… different place. ',
	'You think, maybe you’re in some advanced VR world, and you quickly reach to feel your face (which… feels different—you reach to grab your phone, intending to use the camera to take a look at yourself, but… slight panic—no phone & your pockets are empty). Your own hands are... also different.',
	"You're inclined to look back to the screen display, which (almost as if it knows you're looking) stops showing these Characters, and you’re presented with a couple buttons to choose from….",
];

const IntroSequence = ({ onComplete }) => {
	const [currentChunkIndex, setCurrentChunkIndex] = useState(0);
	const [displayedText, setDisplayedText] = useState('');
	const [showPrompt, setShowPrompt] = useState(false);
	const [showEndButtons, setShowEndButtons] = useState(false);
	const [playVideo, setPlayVideo] = useState(false);

	// Typewriter effect
	useEffect(() => {
		if (playVideo) return;

		const chunk = introTextChunks[currentChunkIndex];
		setDisplayedText(''); // Reset text
		setShowPrompt(false);

		let i = 0;
		const interval = setInterval(() => {
			setDisplayedText(chunk.slice(0, i)); // Slice dynamically
			i++;
			if (i > chunk.length) {
				clearInterval(interval);
				setShowPrompt(true);
			}
		}, 50);

		return () => clearInterval(interval);
	}, [currentChunkIndex, playVideo]);

	const handleNextChunk = () => {
		if (playVideo) return; // Prevent interactions while video is playing

		if (currentChunkIndex < introTextChunks.length - 1) {
			setCurrentChunkIndex(currentChunkIndex + 1);
			setShowPrompt(false);
		} else {
			console.log('End of introTextChunks');
			setShowEndButtons(true);
		}
	};

	return (
		<div className='intro-sequence' onClick={handleNextChunk}>
			{/* Stars warp speed effect */}
			<WarpBackground />
			{/* Top 70% for warp animation or video */}
			<div className='display-top'>
				{!playVideo ? (
					<>
						{!showEndButtons && (
							<div className='text-box'>
								<p className='typewriter'>
									{displayedText}
									{currentChunkIndex === introTextChunks.length - 1 &&
									showPrompt ? null : (
										<span className='cursor'></span>
									)}
								</p>

								{showPrompt && (
									<p className='prompt'>(Tap the screen to continue)</p>
								)}
							</div>
						)}
					</>
				) : (
					<video
						className='video-frame'
						controls
						autoPlay
						onEnded={() => setPlayVideo(false)}>
						<source
							src='/The 1 Odyssey Intro Bio Video.mp4'
							type='video/mp4'
						/>
						Your browser does not support the video tag.
					</video>
				)}
			</div>
			{/* Bottom 30% for buttons */}
			<div className='display-bottom'>
				{showEndButtons && !playVideo && (
					<div>
						<p>
							Select an option below:
							<br />
							<b>Back to Home</b> to return to the Home Page,
							<br />
							or <b>Press Start</b> to play the video about the Characters
							in The City.
						</p>
						<div className='button-group'>
							<button
								className='choice-button'
								onClick={() => (window.location.href = '/')}>
								Back to Home
							</button>
							<span className='or'>or</span>
							<button
								className='choice-button'
								onClick={() => setPlayVideo(true)}>
								Press Start to Play Video
							</button>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default IntroSequence;
